export default __webpack_public_path__ + "static/media/phcs_id_practitioner_ancillary_only.c857aeeb.jpg";